/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:42 2018/11/13
 */
 import * as Vue from 'vue-tsx-support';
 import { Component } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import { default as AgGridVueCustomTsx, ColDefCustom } from '../../../components/agGridCustom/agGridVueCustomTsx';
 import { createBEM, createNamespace } from 'src/util/bem';
 import './stationSetting.less';
 import Bus, { Events } from 'src/util/bus';
 import StationListApi, { StationListDOI } from 'src/pages/stationList/api/stationListApi';
 import { GridOptions } from 'ag-grid-community';
 import NumberRender from 'src/components/agGridComponent/NumberRender';
 import StringRender from 'src/components/agGridComponent/StringRender';
 import { Integer } from 'src/types/base';
 import Input from 'src/types/iview/Input';
 import StationDetailApi, { StationDetailDOI } from '../api/stationDetailApi';
 import Button from 'src/types/iview/Button';
 import EnumEntity from 'src/enums/enumEntity';
 import { Toast } from 'src/util/toast';
 import { type } from 'os';
 import InputNumber from 'src/types/iview/InputNumber';
 let bem = createBEM('station-setting');
 
 export namespace StationSettingVOI{
     export interface FormDataI{
     }
 }
 
 @Component({
     name: 'station-setting',
 })
 export default class StationSettingAlarmUpper extends Vue.Component<any> {
     id: number = -1;
     mn: string = '';
 
     // 附件相关的表格
     gridOptions: GridOptions = {};
 
     columnDefs: ColDefCustom[] = [
         {
             headerName: '设备信息',
             field: 'component_name',
             minWidth: 130
         },
         {
            headerName: '报警下限',
            field: 'alarm_floor_alarms',
            minWidth: 160,
            cellRendererFramework: NumberRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },
          {
             headerName: '报警上限',
             field: 'alarm_ceiling_alarms',
             minWidth: 160,
             cellRendererFramework: NumberRender,
             cellRendererFrameworkOpt: {
                 editable: true,
                 precision: 2
             }
         }
     ];
     get currentStation(): StationListDOI.RowDataI {
         return this.$store.state.stationDetail.currentStation;
     }
     rowData: StationDetailDOI.StationWarnSettingsI[] = [];
 
     formData: StationSettingVOI.FormDataI = {
     }
     loading:boolean = false
 
     async save() {
         this.loading = true
         let {code, data} =  await StationDetailApi.saveStationSettingsAlarms({
             device_id: this.currentStation.id,
             device_name: this.currentStation.name,
             alarm_threshold_value: this.rowData.map(i=> ({component_id: i.component_id, alarm_ceiling_alarms: i.alarm_ceiling_alarms, alarm_floor_alarms: i.alarm_floor_alarms})),
         })
         this.loading = false
         if(code === 0) {
             Toast.success('保存成功')
         }
 
     }
     /**
      * 查询上下线
      */
     async searchComponents() {
         let {code, data} = await StationDetailApi.searchStationWarnSettings(this.id)
         if(code === 0) {
             this.rowData = data
         }
     }
 
     async setFormData() {
         (this.$refs.formValidate as any).resetFields()
         this.searchComponents()
     }
 
     mounted() {
         this.id = +this.$route.query.id;
         this.mn = this.$route.query.mn;
         this.setFormData()
         Bus.$on(Events.StationChange, this.stationChange);   
     }
     stationChange(data: StationListDOI.RowDataI) {
         this.id = data.id;
         this.mn = data.mn;
         this.setFormData()
     }
 
     beforeDestroy() {
         Bus.$off(Events.StationChange, this.stationChange);
     }
 
 
     render(h) {
         return (
             <div class={bem()}>
                 <i-form ref="formValidate"  labelWidth={100} model={this.formData} >
                     <Button style="margin-bottom: 10px; float: right; margin-right: 10px;" loading={this.loading} type="primary" on-click={this.save.bind(this)}>保存</Button>
                 </i-form>
                 <AgGridVueCustomTsx
                     ref="ag"
                     style="flex: 1"
                     gridOptions={this.gridOptions}
                     columnDefs={this.columnDefs}
                     rowData={this.rowData}
                     enableServerSideSorting={false}
                     checkBoxShow={false}
                     pageShow={false}
                 />
             </div>
         );
     }
 }
 